import { Fragment, PropsWithChildren, useCallback, useState } from 'react';
import { View } from 'react-native';
import Collapsible from 'react-native-collapsible';
import { Text, useTheme } from '@ui-kitten/components';

import Button from '../../Components/Button';
import ListItem from '../../Components/ListItem';
import themeStyle from '../../Theme/styles';

type AccordionType = PropsWithChildren<{
  iconName: string;
  title: string;
}>;
const Accordion = ({ children, title, iconName }: AccordionType) => {
  const theme = useTheme();
  const [show, setShow] = useState(false);
  const _toggleShow = useCallback(() => setShow((prev) => !prev), []);
  return (
    <Fragment>
      <Button
        style={themeStyle.pageVerticalSpacingMedium}
        onPress={_toggleShow}
        plain
      >
        <ListItem
          leftIcon={{
            name: iconName,
            color: theme['color-success-500'],
            size: 20,
          }}
          title={<Text category="p2">{title}</Text>}
          rightIcon={{
            name: `chevron-${show ? 'down' : 'right'}`,
            color: theme['color-success-500'],
            size: 20,
          }}
        />
      </Button>
      <Collapsible collapsed={!show}>
        <View
          style={[themeStyle.spacingTopSmall, themeStyle.spacingBottomMedium]}
        >
          {children}
        </View>
      </Collapsible>
    </Fragment>
  );
};

export default Accordion;
